export const ADD_INBOX = 'ADD_INBOX';
export const SET_CONTACT_LIST = 'SET_CONTACT_LIST';
export const SET_SELECTED_CONTACT = 'SET_SELECTED_CONTACT';
export const SET_SELECTED_INBOX = 'SET_SELECTED_INBOX';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_EMAIL_CREDENTIALS = 'SET_EMAIL_CREDENTIALS';
export const SET_EMAIL_LIST = 'SET_EMAIL_LIST';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_SEND_EMAIL = 'SET_SEND_EMAIL';
export const SET_EMAIL_LIST_DATA = 'SET_EMAIL_LIST_DATA';
export const SET_STATISTICS = 'SET_STATISTICS';
export const UPDATE_STATISTICS = 'UPDATE_STATISTICS';
export const SET_LOADING_EMAIL = 'SET_LOADING_EMAIL';
export const SET_SELECTED_CONTACTCC = 'SET_SELECTED_CONTACTCC';
export const SET_SELECTED_CONTACTCCO = 'SET_SELECTED_CONTACTCCO';
export const SET_EMAIL_CONTACT = 'SET_EMAIL_CONTACT';
